
import ImageMeta from "@/mixins/imageMeta.js";

export default {
  name: "SwiperCarrouselSlide",
  props: {
    slide: {
      type: Object,
      default: false,
    },
    photoSwipeActive: {
      type: Boolean,
      default: false,
    },
    fixedHeight: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ImageMeta],
  computed: {
    imageAttributes() {
      return this.getAttribute(this.slide, 'attributes');
    },
  },
}
